import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { requestShippingKit } from "../../actions/shipment";
import { imageUrl } from 'helpers/ApplicationHelper';
import I18n from 'lib/i18n/i18n';
import Listing from './../listing/listing'

import { isMobile, DELIVERED } from 'helpers/ApplicationHelper';
import UserActions from "lib/userActions";

class ShippingKit extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
        this.isMobile = isMobile();
    }

    logAction = (message) => {
        if (this.props.logger) {
            this.props.logger(message);
        } else {
            UserActions.listingPage(message, this.props.item.id, Listing.getVersion(this.props));
        }
    }

    toggleInnerPopup = (show = false) => {
        const { onShowInnerPopup } = this.props;
        if (show) {
            this.logAction('Get our free shipping kit link - clicked');
            if (onShowInnerPopup) {
                onShowInnerPopup();
            }
        } else {
            this.logAction('Get shipping kit - canceled');
        }
    }

    render() {
        const { item } = this.props;
        const packingSteps = I18n.getVar('shippingKit::steps');

        return <div className={"shipping-kit"}>
            <p className={'description'}
               key={'step3-description'}>
                { I18n.getString('shippingKit::description') }
            </p>
            <ol className='shipping-kit-steps-list'>
                {
                    packingSteps.map((step, idx) => <li key={idx} className='shipping-kit-step'>
                        <span className='shipping-kit-step-image' title={ `Step ${ idx + 1 }` } style={{ backgroundImage:  'url(' + imageUrl(`shippingKit/step_${idx}.svg`) + ')' }}/>
                        <p className='shipping-kit-step-caption'>{ step }</p>
                    </li>)
                }
            </ol>
            {
                item.shipping_kit && item.shipping_kit.status === DELIVERED ? null : <p className='shipping-kit-missing-everything'>
                    <span>{ I18n.getString('shippingKit::ctaBlockTitle') }</span>
                    <b onClick={ () => this.toggleInnerPopup(true) } data-automation='shipping-kit-flah'>
                        { I18n.getString('shippingKit::ctaBlockDescription') }
                    </b>
                </p>
            }
        </div>
    }
}

const mapStateToProps = ({ Item, Session, Experiments, ADO, Personalized }) => {
    return {
        ADO,
        item: Item,
        session: Session,
        experiments: Experiments,
        P13N: Personalized,
    }
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({ requestShippingKit }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(ShippingKit);
